import { pgTable, text, uuid, index } from "drizzle-orm/pg-core";

import { baseTableProps } from "../../baseTableProps";
import { companies } from "../companies/companies.model";
import { addresses } from "../addresses/addresses.model";
import { displayNameProps } from "../_shared/display-name";

export const contacts = pgTable(
	"contacts",
	{
		...baseTableProps,
		firstName: text("first_name").notNull(),
		preferredName: text("preferred_name"),
		lastName: text("last_name").notNull(),
		email: text("email"),
		phone: text("phone"),
		companyId: uuid("company_id").references(() => companies.id),
		...displayNameProps
	},
	(table) => [index("contacts_company_idx").on(table.companyId)]
);

export const xContactAddresses = pgTable(
	"x_contact_addresses",
	{
		...baseTableProps,
		contactId: uuid("contact_id")
			.references(() => contacts.id, { onDelete: "cascade" })
			.notNull(),
		addressId: uuid("address_id")
			.references(() => addresses.id, { onDelete: "cascade" })
			.notNull()
	},
	(table) => [
		index("x_contact_addresses_contact_id_idx").on(table.contactId),
		index("x_contact_addresses_address_id_idx").on(table.addressId)
	]
);
